import {
  CorpInfoModel,
  IndustryMstMiddleModel,
  IndustryMstModel,
} from "models";
import React from "react";

type PROPS = {
  mst: IndustryMstModel[];
  data: CorpInfoModel;
  disabled?: boolean;
  // children?: ReactNode;
};

const IndustryMstSelect: React.FC<PROPS> = (props) => {
  const [majorItems, setMajorItems] = React.useState<IndustryMstModel[]>([]);
  const [middleItems, setMiddleItems] = React.useState<
    IndustryMstMiddleModel[]
  >([]);

  const [majorCd, setMajorCd] = React.useState("");
  const [middleCd, setMiddleCd] = React.useState("");

  React.useEffect(() => {
    const mjrCd = props.data.industry_major_cd;
    const mdlCd = props.data.industry_middle_cd;

    setMajorItems(props.mst);
    setMajorCd(mjrCd);

    const mjr = props.mst.find((v) => v.mjr_cd === mjrCd);
    if (mjr && mjr.middle_list) {
      const mdl = mjr.middle_list.find((v) => v.mid_cd === mdlCd);
      if (mdl) {
        setMiddleItems(mjr.middle_list);
        setMiddleCd(mdlCd);
      }
    } else {
      setMiddleItems([]);
      setMiddleCd("");
    }
  }, [props.data, props.mst]);

  return (
    <div className="flex-1 flex items-center gap-2">
      <select
        className="flex-1"
        value={majorCd}
        onChange={(e) => {
          const value = e.target.value;
          setMajorCd(value);
          props.data.industry_major_cd = value;
          props.data.industry_middle_cd = "";

          const mjr = props.mst.find((v) => v.mjr_cd === value);
          if (mjr) {
            setMiddleItems(mjr.middle_list ?? []);
          } else {
            setMiddleItems([]);
          }
          setMiddleCd("");
        }}
        disabled={props.disabled}
      >
        <option value="">選択してください</option>
        {majorItems.map((v, i) => {
          return (
            <option key={i} value={v.mjr_cd}>
              {v.mjr_cd}:{v.title}
            </option>
          );
        })}
      </select>
      <select
        className="flex-1"
        value={middleCd}
        onChange={(e) => {
          const value = e.target.value;
          setMiddleCd(value);
          props.data.industry_middle_cd = value;
        }}
        disabled={props.disabled || majorCd === ""}
        // disabled={props.disabled}
      >
        <option value="">選択してください</option>
        {middleItems.map((v, i) => {
          return (
            <option key={i} value={v.mid_cd}>
              {v.mid_cd}:{v.title}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default IndustryMstSelect;
